;(function ($, window) {
  'use strict'

  // setup a shared namespace, if needed
  window.GCO = window.GCO || {}

  window.GCO.global = (function () {
    function init () {
      // kick off here

      $('.scroll').click(function (event) {
        event.preventDefault()
        $('html,body').animate({
          scrollTop: $(this.hash).offset().top
        }, 900)
      })
    }

    return {
      init: init
    }
  }())

  $(document).ready(function () {
    GCO.global.init()
  })
}(jQuery, window))
